export default function compact<T extends Record<string,unknown>>(object: T): T {
  return Object.fromEntries(Object.entries(object).filter(([_key, value]) => value !== undefined)) as T
}
